/* Scroll & Nav Active Tracker */
const navEl = document.querySelector('nav');
const anchors = document.querySelectorAll('nav a:not([target=_blank])');
const anchoredElements = [...anchors].map(anchor => {
    const href = anchor.getAttribute('href');
    return href && href.startsWith('#') ? document.querySelector(href) : null;
}).filter(Boolean);

const elementToNavAnchor = new Map(anchoredElements.map((element, index) => [element, anchors[index]]));
let oldScroll = window.scrollY;

function checkVisible(elm: Element, threshold = 150) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const above = rect.bottom - threshold < 0;
    const below = rect.top - viewHeight + threshold >= 0;
    return !above && !below;
}

function updateNavSelection() {
    let activeSet = false;
    for (const anchoredElement of anchoredElements) {
        if (!anchoredElement) continue;
        const visible = checkVisible(anchoredElement);
        const anchor = elementToNavAnchor.get(anchoredElement);
        if (anchor) {
            anchor.classList.toggle('active', !activeSet && visible);
            if (!activeSet && visible) activeSet = true;
        }
    }
}

window.addEventListener('scroll', () => {
    oldScroll = window.scrollY;
    updateNavSelection();
}, { passive: true });

/* Mobile Menu Navigation */
const navButton = document.querySelector('.menu-toggle');
navButton?.addEventListener('click', () => {
    navButton.classList.toggle('open');
    navEl?.classList.toggle('open');
});

navEl?.addEventListener('click', (event) => {
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    if (event.target instanceof HTMLAnchorElement) {
        navButton?.classList.remove('open');
        navEl.classList.remove('open');
    }
});

/* Accordion Widget */
document.querySelectorAll('[data-role=expandable]').forEach(expandable => {
    const title = expandable.querySelector('[data-role=title]');
    const content = expandable.querySelector('[data-role=content]');
    
    // Ensure inner wrapper exists for CSS Grid transition
    if (content && !content.querySelector('[data-role=inner]')) {
        const inner = document.createElement('div');
        inner.setAttribute('data-role', 'inner');
        while (content.firstChild) {
            inner.appendChild(content.firstChild);
        }
        content.appendChild(inner);
    }

    title?.setAttribute('role', 'button');
    title?.setAttribute('tabindex', '0');

    const toggle = () => {
        const isExpanded = expandable.classList.toggle('expanded');
        title.setAttribute('aria-expanded', String(isExpanded));
    };

    title?.addEventListener('click', toggle);
    title?.addEventListener('keydown', (e: Event) => {
        const keyboardEvent = e as KeyboardEvent;
        if (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ') {
            keyboardEvent.preventDefault();
            toggle();
        }
    });
});

/* Read More Widget */
document.querySelectorAll('[data-role=read_more]').forEach(expandable => {
    const buttonContainer = expandable.querySelector('[data-role=expand]');
    const parent = expandable.closest('.article-section');

    buttonContainer?.addEventListener('click', event => {
        const target = expandable as HTMLElement;
        const currentState = target.dataset.expandState;
        if (currentState === 'open' && parent) {
            parent.scrollIntoView({ behavior: 'smooth' });
        }
        event.stopPropagation();
        event.preventDefault();
        target.dataset.expandState = currentState === 'closed' ? 'open' : 'closed';
    });
});

/* Reference Dialog */
const dialog = document.querySelector('dialog.reference_dialog') as HTMLDialogElement | null;
const openDialogBtn = document.querySelector('[data-role=open_dialog]');
const closeDialogBtn = document.querySelector('dialog .dialog-close');

openDialogBtn?.addEventListener('click', () => {
    dialog?.showModal();
});

closeDialogBtn?.addEventListener('click', () => {
    dialog?.close();
});

dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) {
        dialog.close();
    }
});
